import React from 'react';
import { CoreBumpRecommendationListing } from '../../schemas/rql';
import { ChildProps } from 'react-apollo';
import { fixPrecision } from './bump_helpers';
import { BumpModal } from './bump_modal';
import { BUMPED_LISTING_RECOMMENDATION_QUERY, CoreBumpListingCardQueryProps } from './bump_listing_query';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

export interface BumpV2ModalContainerProps {
  listingId: string;
  bid: number;
  selectedBid: number;
  successMessage: string;
  failMessage: string;
  handleBidChange: (bid: number) => void;
  updateBid: (
    bid: number,
    bumpRecommendationAmount: number,
    listing: CoreBumpRecommendationListing.Listing,
    refetch: () => void,
  ) => void;
  refetch: () => void;
  onRequestClose?: Function;
}

type Props = ChildProps<BumpV2ModalContainerProps &
CoreBumpListingCardQueryProps,
CoreBumpRecommendationListing.Query
>;

export function recommendationAmount(
  listing: CoreBumpRecommendationListing.Listing,
): number {
  return fixPrecision(listing.bumpRecommendations.bumpRecommendationAmount);
}

export function BumpV2ModalContainer(props: Props) {

  const loading = props.data?.loading;
  const listing = props.data?.listing;

  if (loading || !listing) {
    return null;
  }

  const bumpRecommendationAmount = recommendationAmount(
    listing,
  );

  return (
    <BumpModal
      recommendationAmount={bumpRecommendationAmount}
      listing={listing}
      bid={props.bid}
      selectedBid={props.selectedBid}
      handleBidChange={props.handleBidChange}
      updateBid={props.updateBid}
      successMessage={props.successMessage}
      failMessage={props.failMessage}
      refetch={props.refetch}
      onRequestClose={props.onRequestClose}
    />
  );
}

const coreBumpRecommendationListingCardQuery = withGraphql<
BumpV2ModalContainerProps,
CoreBumpRecommendationListing.Query
>(
  BUMPED_LISTING_RECOMMENDATION_QUERY,
  {
    options: (ownProps) => {
      return {
        ssr: false, // modal doesnt need to be server side rendered
        errorPolicy: 'all',
        variables: {
          id: ownProps.listingId,
        },
      };
    },
  },
);

export default coreBumpRecommendationListingCardQuery(BumpV2ModalContainer);
